import { render, staticRenderFns } from "./ArticlesOfAgreement_en.vue?vue&type=template&id=1cc5c236&scoped=true&"
import script from "./ArticlesOfAgreement_en.vue?vue&type=script&lang=js&"
export * from "./ArticlesOfAgreement_en.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesOfAgreement_en.vue?vue&type=style&index=0&id=1cc5c236&lang=scss&rel=text%2Fcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc5c236",
  null
  
)

export default component.exports